export const SpendData = [
    {
      "model": "independent",
      "month": "2025-01",
      "predicted_spend_commitment": 100000,
      "actual_spend": 110000,
      "gap_to_commitment": 10000,
      "country": "AU"
    },
    {
      "model": "independent",
      "month": "2025-02",
      "predicted_spend_commitment": 100000,
      "actual_spend": 130000,
      "gap_to_commitment": 30000,
      "country": "AU"
    },
    {
      "model": "independent",
      "month": "2025-03",
      "predicted_spend_commitment": 100000,
      "actual_spend": 95000,
      "gap_to_commitment": -5000,
      "country": "AU"
    },
    {
      "model": "independent",
      "month": "2025-04",
      "predicted_spend_commitment": 100000,
      "actual_spend": 105000,
      "gap_to_commitment": 5000,
      "country": "AU"
    },
    {
      "model": "independent",
      "month": "2025-05",
      "predicted_spend_commitment": 100000,
      "actual_spend": 125000,
      "gap_to_commitment": 25000,
      "country": "AU"
    },
    {
      "model": "independent",
      "month": "2025-06",
      "predicted_spend_commitment": 100000,
      "actual_spend": 195000,
      "gap_to_commitment": 95000,
      "country": "AU"
    },
    {
      "model": "independent",
      "month": "2025-07",
      "predicted_spend_commitment": 100000,
      "actual_spend": 99000,
      "gap_to_commitment": -1000,
      "country": "AU"
    },
    {
      "model": "independent",
      "month": "2025-08",
      "predicted_spend_commitment": 100000,
      "actual_spend": 112000,
      "gap_to_commitment": 12000,
      "country": "AU"
    },
    {
      "model": "independent",
      "month": "2025-09",
      "predicted_spend_commitment": 100000,
      "actual_spend": 121000,
      "gap_to_commitment": 21000,
      "country": "AU"
    },
    {
      "model": "independent",
      "month": "2025-10",
      "predicted_spend_commitment": 100000,
      "actual_spend": 141000,
      "gap_to_commitment": 41000,
      "country": "AU"
    },
    {
      "model": "independent",
      "month": "2025-11",
      "predicted_spend_commitment": 100000,
      "actual_spend": 210000,
      "gap_to_commitment": 110000,
      "country": "AU"
    },
    {
      "model": "independent",
      "month": "2025-12",
      "predicted_spend_commitment": 100000,
      "actual_spend": 95000,
      "gap_to_commitment": -5000,
      "country": "AU"
    },
    {
      "model": "unified-discount",
      "month": "2025-01",
      "predicted_spend_commitment": 100000,
      "actual_spend": 110000,
      "gap_to_commitment": 10000,
      "country": "AU"
    },
    {
      "model": "unified-discount",
      "month": "2025-02",
      "predicted_spend_commitment": 100000,
      "actual_spend": 130000,
      "gap_to_commitment": 30000,
      "country": "AU"
    },
    {
      "model": "unified-discount",
      "month": "2025-03",
      "predicted_spend_commitment": 100000,
      "actual_spend": 95000,
      "gap_to_commitment": -5000,
      "country": "AU"
    },
    {
      "model": "unified-discount",
      "month": "2025-04",
      "predicted_spend_commitment": 100000,
      "actual_spend": 105000,
      "gap_to_commitment": 5000,
      "country": "AU"
    },
    {
      "model": "unified-discount",
      "month": "2025-05",
      "predicted_spend_commitment": 100000,
      "actual_spend": 125000,
      "gap_to_commitment": 25000,
      "country": "AU"
    },
    {
      "model": "unified-discount",
      "month": "2025-06",
      "predicted_spend_commitment": 100000,
      "actual_spend": 195000,
      "gap_to_commitment": 95000,
      "country": "AU"
    },
    {
      "model": "unified-discount",
      "month": "2025-07",
      "predicted_spend_commitment": 100000,
      "actual_spend": 99000,
      "gap_to_commitment": -1000,
      "country": "AU"
    },
    {
      "model": "unified-discount",
      "month": "2025-08",
      "predicted_spend_commitment": 100000,
      "actual_spend": 112000,
      "gap_to_commitment": 12000,
      "country": "AU"
    },
    {
      "model": "unified-discount",
      "month": "2025-09",
      "predicted_spend_commitment": 100000,
      "actual_spend": 121000,
      "gap_to_commitment": 21000,
      "country": "AU"
    },
    {
      "model": "unified-discount",
      "month": "2025-10",
      "predicted_spend_commitment": 100000,
      "actual_spend": 141000,
      "gap_to_commitment": 41000,
      "country": "AU"
    },
    {
      "model": "unified-discount",
      "month": "2025-11",
      "predicted_spend_commitment": 100000,
      "actual_spend": 210000,
      "gap_to_commitment": 110000,
      "country": "AU"
    },
    {
      "model": "unified-discount",
      "month": "2025-12",
      "predicted_spend_commitment": 100000,
      "actual_spend": 95000,
      "gap_to_commitment": -5000,
      "country": "AU"
    },
    {
      "model": "unified-rewards",
      "month": "2025-01",
      "predicted_spend_commitment": 100000,
      "actual_spend": 110000,
      "gap_to_commitment": 10000,
      "country": "AU"
    },
    {
      "model": "unified-rewards",
      "month": "2025-02",
      "predicted_spend_commitment": 100000,
      "actual_spend": 130000,
      "gap_to_commitment": 30000,
      "country": "AU"
    },
    {
      "model": "unified-rewards",
      "month": "2025-03",
      "predicted_spend_commitment": 100000,
      "actual_spend": 95000,
      "gap_to_commitment": -5000,
      "country": "AU"
    },
    {
      "model": "unified-rewards",
      "month": "2025-04",
      "predicted_spend_commitment": 100000,
      "actual_spend": 105000,
      "gap_to_commitment": 5000,
      "country": "AU"
    },
    {
      "model": "unified-rewards",
      "month": "2025-05",
      "predicted_spend_commitment": 100000,
      "actual_spend": 125000,
      "gap_to_commitment": 25000,
      "country": "AU"
    },
    {
      "model": "unified-rewards",
      "month": "2025-06",
      "predicted_spend_commitment": 100000,
      "actual_spend": 195000,
      "gap_to_commitment": 95000,
      "country": "AU"
    },
    {
      "model": "unified-rewards",
      "month": "2025-07",
      "predicted_spend_commitment": 100000,
      "actual_spend": 99000,
      "gap_to_commitment": -1000,
      "country": "AU"
    },
    {
      "model": "unified-rewards",
      "month": "2025-08",
      "predicted_spend_commitment": 100000,
      "actual_spend": 112000,
      "gap_to_commitment": 12000,
      "country": "AU"
    },
    {
      "model": "unified-rewards",
      "month": "2025-09",
      "predicted_spend_commitment": 100000,
      "actual_spend": 121000,
      "gap_to_commitment": 21000,
      "country": "AU"
    },
    {
      "model": "unified-rewards",
      "month": "2025-10",
      "predicted_spend_commitment": 100000,
      "actual_spend": 141000,
      "gap_to_commitment": 41000,
      "country": "AU"
    },
    {
      "model": "unified-rewards",
      "month": "2025-11",
      "predicted_spend_commitment": 100000,
      "actual_spend": 210000,
      "gap_to_commitment": 110000,
      "country": "AU"
    },
    {
      "model": "unified-rewards",
      "month": "2025-12",
      "predicted_spend_commitment": 100000,
      "actual_spend": 95000,
      "gap_to_commitment": -5000,
      "country": "AU"
    },
    {
      "model": "independent",
      "month": "2025-01",
      "predicted_spend_commitment": 30000,
      "actual_spend": 22000,
      "gap_to_commitment": -8000,
      "country": "NZ"
    },
    {
      "model": "independent",
      "month": "2025-02",
      "predicted_spend_commitment": 30000,
      "actual_spend": 24000,
      "gap_to_commitment": -6000,
      "country": "NZ"
    },
    {
      "model": "independent",
      "month": "2025-03",
      "predicted_spend_commitment": 30000,
      "actual_spend": 35000,
      "gap_to_commitment": 5000,
      "country": "NZ"
    },
    {
      "model": "independent",
      "month": "2025-04",
      "predicted_spend_commitment": 30000,
      "actual_spend": 31000,
      "gap_to_commitment": 1000,
      "country": "NZ"
    },
    {
      "model": "independent",
      "month": "2025-05",
      "predicted_spend_commitment": 30000,
      "actual_spend": 49000,
      "gap_to_commitment": 19000,
      "country": "NZ"
    },
    {
      "model": "independent",
      "month": "2025-06",
      "predicted_spend_commitment": 30000,
      "actual_spend": 58000,
      "gap_to_commitment": 28000,
      "country": "NZ"
    },
    {
      "model": "independent",
      "month": "2025-07",
      "predicted_spend_commitment": 30000,
      "actual_spend": 26000,
      "gap_to_commitment": -4000,
      "country": "NZ"
    },
    {
      "model": "independent",
      "month": "2025-08",
      "predicted_spend_commitment": 30000,
      "actual_spend": 22000,
      "gap_to_commitment": -8000,
      "country": "NZ"
    },
    {
      "model": "independent",
      "month": "2025-09",
      "predicted_spend_commitment": 30000,
      "actual_spend": 37000,
      "gap_to_commitment": 7000,
      "country": "NZ"
    },
    {
      "model": "independent",
      "month": "2025-10",
      "predicted_spend_commitment": 30000,
      "actual_spend": 31000,
      "gap_to_commitment": 1000,
      "country": "NZ"
    },
    {
      "model": "independent",
      "month": "2025-11",
      "predicted_spend_commitment": 30000,
      "actual_spend": 65000,
      "gap_to_commitment": 35000,
      "country": "NZ"
    },
    {
      "model": "independent",
      "month": "2025-12",
      "predicted_spend_commitment": 30000,
      "actual_spend": 24000,
      "gap_to_commitment": -6000,
      "country": "NZ"
    },
    {
      "model": "unified-discount",
      "month": "2025-01",
      "predicted_spend_commitment": 30000,
      "actual_spend": 22000,
      "gap_to_commitment": -8000,
      "country": "NZ"
    },
    {
      "model": "unified-discount",
      "month": "2025-02",
      "predicted_spend_commitment": 30000,
      "actual_spend": 24000,
      "gap_to_commitment": -6000,
      "country": "NZ"
    },
    {
      "model": "unified-discount",
      "month": "2025-03",
      "predicted_spend_commitment": 30000,
      "actual_spend": 35000,
      "gap_to_commitment": 5000,
      "country": "NZ"
    },
    {
      "model": "unified-discount",
      "month": "2025-04",
      "predicted_spend_commitment": 30000,
      "actual_spend": 31000,
      "gap_to_commitment": 1000,
      "country": "NZ"
    },
    {
      "model": "unified-discount",
      "month": "2025-05",
      "predicted_spend_commitment": 30000,
      "actual_spend": 49000,
      "gap_to_commitment": 19000,
      "country": "NZ"
    },
    {
      "model": "unified-discount",
      "month": "2025-06",
      "predicted_spend_commitment": 30000,
      "actual_spend": 58000,
      "gap_to_commitment": 28000,
      "country": "NZ"
    },
    {
      "model": "unified-discount",
      "month": "2025-07",
      "predicted_spend_commitment": 30000,
      "actual_spend": 26000,
      "gap_to_commitment": -4000,
      "country": "NZ"
    },
    {
      "model": "unified-discount",
      "month": "2025-08",
      "predicted_spend_commitment": 30000,
      "actual_spend": 22000,
      "gap_to_commitment": -8000,
      "country": "NZ"
    },
    {
      "model": "unified-discount",
      "month": "2025-09",
      "predicted_spend_commitment": 30000,
      "actual_spend": 37000,
      "gap_to_commitment": 7000,
      "country": "NZ"
    },
    {
      "model": "unified-discount",
      "month": "2025-10",
      "predicted_spend_commitment": 30000,
      "actual_spend": 31000,
      "gap_to_commitment": 1000,
      "country": "NZ"
    },
    {
      "model": "unified-discount",
      "month": "2025-11",
      "predicted_spend_commitment": 30000,
      "actual_spend": 65000,
      "gap_to_commitment": 35000,
      "country": "NZ"
    },
    {
      "model": "unified-discount",
      "month": "2025-12",
      "predicted_spend_commitment": 30000,
      "actual_spend": 24000,
      "gap_to_commitment": -6000,
      "country": "NZ"
    },
    {
      "model": "unified-rewards",
      "month": "2025-01",
      "predicted_spend_commitment": 30000,
      "actual_spend": 22000,
      "gap_to_commitment": -8000,
      "country": "NZ"
    },
    {
      "model": "unified-rewards",
      "month": "2025-02",
      "predicted_spend_commitment": 30000,
      "actual_spend": 24000,
      "gap_to_commitment": -6000,
      "country": "NZ"
    },
    {
      "model": "unified-rewards",
      "month": "2025-03",
      "predicted_spend_commitment": 30000,
      "actual_spend": 35000,
      "gap_to_commitment": 5000,
      "country": "NZ"
    },
    {
      "model": "unified-rewards",
      "month": "2025-04",
      "predicted_spend_commitment": 30000,
      "actual_spend": 31000,
      "gap_to_commitment": 1000,
      "country": "NZ"
    },
    {
      "model": "unified-rewards",
      "month": "2025-05",
      "predicted_spend_commitment": 30000,
      "actual_spend": 49000,
      "gap_to_commitment": 19000,
      "country": "NZ"
    },
    {
      "model": "unified-rewards",
      "month": "2025-06",
      "predicted_spend_commitment": 30000,
      "actual_spend": 58000,
      "gap_to_commitment": 28000,
      "country": "NZ"
    },
    {
      "model": "unified-rewards",
      "month": "2025-07",
      "predicted_spend_commitment": 30000,
      "actual_spend": 26000,
      "gap_to_commitment": -4000,
      "country": "NZ"
    },
    {
      "model": "unified-rewards",
      "month": "2025-08",
      "predicted_spend_commitment": 30000,
      "actual_spend": 22000,
      "gap_to_commitment": -8000,
      "country": "NZ"
    },
    {
      "model": "unified-rewards",
      "month": "2025-09",
      "predicted_spend_commitment": 30000,
      "actual_spend": 37000,
      "gap_to_commitment": 7000,
      "country": "NZ"
    },
    {
      "model": "unified-rewards",
      "month": "2025-10",
      "predicted_spend_commitment": 30000,
      "actual_spend": 31000,
      "gap_to_commitment": 1000,
      "country": "NZ"
    },
    {
      "model": "unified-rewards",
      "month": "2025-11",
      "predicted_spend_commitment": 30000,
      "actual_spend": 65000,
      "gap_to_commitment": 35000,
      "country": "NZ"
    },
    {
      "model": "unified-rewards",
      "month": "2025-12",
      "predicted_spend_commitment": 30000,
      "actual_spend": 24000,
      "gap_to_commitment": -6000,
      "country": "NZ"
    }
  ]